const user = (state = {}, action) => {
  switch (action.type) {
    case "messageTokenAuthResponse":

    case "facebookSignUpResponse":
    case "userSignUpResponse":
    case "facebookSignInResponse":
    case "userSignInResponse": {

      return {
        ...state,
        ...action.user
      }
    }
    case "loginUserProfileResponse": {

      return {
        ...state,
        userProfile: action.userProfile

      }
    }
    case "completelogout": {

      return {

      }
    }
    case "contactProfileResponse": {

      var {contactProfileResponse} = action

      return {
        ...state,
        contactList: state.userProfile.contacts.reduce((contacts, contactId) => {

          if (contactProfileResponse.userId == contactId) {

            return [...contacts, contactProfileResponse]

          } else {

            return [...contacts, {
              userId: contactId
            }]
          }

        }, [])
      }

    }
    default:
      return state;
  }

}

export default user;


// WEBPACK FOOTER //
// ./src/reducers/user/index.js